(function () {
  var html = document.documentElement;
  var btn = document.querySelector('[data-theme-toggle]');
  if (!html || !btn) return;

  var key = 'edas-theme';
  var saved = null;
  try {
    saved = localStorage.getItem(key);
  } catch (e) {
    saved = null;
  }

  // Crear o actualizar el icono lucide y el span de texto
  function createOrUpdateIcon(isDark) {
    // Remover icono existente
    var existingIcon = btn.querySelector('[data-lucide]');
    if (existingIcon) {
      existingIcon.remove();
    }

    // Crear nuevo icono
    var icon = document.createElement('i');
    icon.setAttribute('data-lucide', isDark ? 'moon' : 'sun');
    btn.insertBefore(icon, btn.firstChild);

    // Reinicializar lucide si está disponible
    if (typeof lucide !== 'undefined' && lucide.createIcons) {
      lucide.createIcons();
    }
  }

  function apply(mode) {
    var isDark = mode === 'dark';
    html.setAttribute('data-theme', isDark ? 'dark' : 'light');
    btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');

    // Actualizar icono dinámicamente
    createOrUpdateIcon(isDark);

    // Actualizar texto
    var textNode = btn.querySelector('span');
    if (textNode) {
      textNode.textContent = isDark ? 'Modo claro' : 'Modo oscuro';
    } else {
      // Crear span si no existe
      var span = document.createElement('span');
      span.textContent = isDark ? 'Modo claro' : 'Modo oscuro';
      btn.appendChild(span);
    }

    try {
      localStorage.setItem(key, isDark ? 'dark' : 'light');
    } catch (e) {
      // localStorage no disponible, ignorar
    }
  }

  // Determinar tema inicial: localStorage > data-theme actual > light
  var initialTheme = saved;
  if (!initialTheme) {
    initialTheme = html.getAttribute('data-theme') || 'light';
  }

  apply(initialTheme === 'dark' ? 'dark' : 'light');

  btn.addEventListener('click', function () {
    var current = html.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    apply(current === 'dark' ? 'light' : 'dark');
  });
})();

